module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-Head-fmh-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#cglo",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Glossary of Terms")])])]), _vm._v(" "), _c('p', {
    staticClass: "Glossary-Term-glt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("BGF")]), _vm._v("—the Black Guerrilla Family gang")]), _vm._v(" "), _c('p', {
    staticClass: "Glossary-Term-glt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Dark Web")]), _vm._v("—an unindexed part of the Internet accessible only through an encrypted browser")]), _vm._v(" "), _c('p', {
    staticClass: "Glossary-Term-glt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("dope, raw")]), _vm._v("—heroin")]), _vm._v(" "), _c('p', {
    staticClass: "Glossary-Term-glt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("dope sick")]), _vm._v("—sickness caused by withdrawal from opiates")]), _vm._v(" "), _c('p', {
    staticClass: "Glossary-Term-glt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("enforcer")]), _vm._v("—a gang member who commits homicides and other acts of violence to protect his gang’s interests")]), _vm._v(" "), _c('p', {
    staticClass: "Glossary-Term-glt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("field marshal")]), _vm._v("—a high-ranking member of BGF; usually oversees a team of enforcers")]), _vm._v(" "), _c('p', {
    staticClass: "Glossary-Term-glt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Frankenstein")]), _vm._v("—heroin cut with fentanyl")]), _vm._v(" "), _c('p', {
    staticClass: "Glossary-Term-glt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("hot shot")]), _vm._v("—a deadly dose of heroin")]), _vm._v(" "), _c('p', {
    staticClass: "Glossary-Term-glt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Percs")]), _vm._v("—Percocet")]), _vm._v(" "), _c('p', {
    staticClass: "Glossary-Term-glt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Pill City")]), _vm._v("—a Baltimore-based drug syndicate founded in April 2015")]), _vm._v(" "), _c('p', {
    staticClass: "Glossary-Term-glt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("re-up")]), _vm._v("—to obtain a new supply of drugs from one’s supplier")]), _vm._v(" "), _c('p', {
    staticClass: "Glossary-Term-glt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("rig")]), _vm._v("—a syringe")]), _vm._v(" "), _c('p', {
    staticClass: "Glossary-Term-glt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("riot pills")]), _vm._v("—pills stolen during the April 2015 riots")]), _vm._v(" "), _c('p', {
    staticClass: "Glossary-Term-glt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Roxys")]), _vm._v("—Roxicodone")]), _vm._v(" "), _c('p', {
    staticClass: "Glossary-Term-glt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("spike")]), _vm._v("—an unused needle")]), _vm._v(" "), _c('p', {
    staticClass: "Glossary-Term-glt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("twin")]), _vm._v("—a communal syringe shared by multiple addicts")]), _vm._v(" "), _c('p', {
    staticClass: "Glossary-Term-glt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("vacant")]), _vm._v("—an abandoned property, usually a rowhome, in Baltimore City")]), _vm._v(" "), _c('p', {
    staticClass: "Glossary-Term-glt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Vikes")]), _vm._v("—Vicodin")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45c30e40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/glossary.vue
// module id = 78
// module chunks = 0